import React, { useEffect, useState } from "react";
import { Col, Input, Row, Table, Tooltip } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment";
import { DownloadOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { URL } from "../../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import Api from "../../Redux/common/api";
function Product() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  const { confirm } = Modal;

  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;

  const get_product_list = useSelector((state) =>
    state?.allapi?.get_product_list ? state?.allapi?.get_product_list : {}
  );

  console.log("pg render");
  const [pages, setPage] = useState(1);

  const listdata = get_product_list?.docs ? get_product_list?.docs : [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setuserId] = useState("");

  const [statusData, setstatusData] = useState({});
  const [userData, setuserData] = useState({});
  const [statusDataBox, setstatusDataBox] = useState(false);

  const [managerKey, setManagerKey] = useState(0);
  const [userselete, setuserselete] = useState(null);

  const loadOptionsPalyer = async (search, loadedOptions, page) => {
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/getuserforlinsense?search=${search}&page=${page?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?.id;
      data.label = data?.fullName + "-" + data?.referId + "-" + data?.phone;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page?.page + 1,
      },
    };
  };

  const getPropertiesData = () => {
    if (search) {
      dispatch(allapiAction.searchProduct({ page: page, key: search }));
    } else {
      dispatch(allapiAction.getProductList(page));
    }
  };
  useEffect(() => {
    if (search) {
      dispatch(allapiAction.searchProduct({ page: page, key: search }));
    } else {
      dispatch(allapiAction.getProductList(page));
    }

    return () => {};
  }, [location]);

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    // setShowDelete(false);
    dispatch(allapiAction.deleteProduct({ productId: e, pageNo: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const hendleToViewM = (e) => {
    if (e?.sold == "1") {
      toast.error("plot Already Sold");
    } else {
      setstatusDataBox(true);
      setuserData(e);
    }
  };

  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };

  const hendleToSubmetUpdate = async () => {
    if (!statusData?.amount) {
      toast.error("Please enter amount");
      return;
    }
    if (!statusData?.paymentMode) {
      toast.error("Please select payment mode");
      return;
    }
    if (statusData?.paymentMode !== "case" && !statusData?.transationId) {
      toast.error("Please enter transaction Id");

      return;
    }

    const response = await dispatch(
      allapiAction.createOrderByAdmin({
        packageId: userData?._id,
        amount: statusData?.amount,
        transationId: statusData?.transationId,
        paymentMode: statusData?.paymentMode,
        user_id: userselete?._id,

        pageNumber: page,
      })
    );
    if (response?.success) {
      setstatusDataBox(false);
      getPropertiesData();
    } else {
      toast.error(response?.message);
    }
  };

  const showModal = (e) => {
    console.log(e);
    setuserId(e);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    dispatch(
      allapiAction.user_inactive({
        _id: userId,
        status: userId,
        // active: 0,
        pageNumber: page,
      })
    );
    setuserId("");
    setIsModalOpen(false);
    return () => {};
  };

  const hendleToChangeStatus = (id, status) => {
    dispatch(
      allapiAction.user_inactive({
        _id: id,
        status: status,
        // active: 0,
        pageNumber: page,
      })
    );
    // setuserId("");
    // setIsModalOpen(false);
    return () => {};
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusProduct({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };
  const hendleToproStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusFranchiesProduct({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img
    //             style={{ width: "100%" }}
    //             src={URL?.API_BASE_URL + item?.featureImage}
    //             alt=""
    //           />
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Scheme Name",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.categorymainId?.name}
            </span>
          </>
        );
      },
    },

    {
      title: "Plot Number",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Gaj",
      dataIndex: "gaj",
      key: "gaj",
    },
    {
      title: "Par Gaj Price",
      dataIndex: "price2",
      key: "price2",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      className: "table_action_col",
      render: (value, item, index) => {
        return <>{item?.price}</>;
      },
    },
    {
      title: "Sold",
      dataIndex: "sold",
      key: "sold",
      className: "table_action_col",
      render: (value, item, index) => {
        return <>{item?.sold == 0 ? "No" : "Yes"}</>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.status}>
              <button
                className={
                  item?.status == "Active"
                    ? "success-button ml-3"
                    : "delete-button2 ml-3"
                }
                onClick={() =>
                  hendleToStatus(
                    item?._id,
                    item?.status == "Active" ? "Inactive" : "Active"
                  )
                }
              >
                {item?.status}
              </button>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => navigate(`/update-product/${item?.pro_sulg}`)}
              >
                <SvgIcon.Pencil className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title={"sale"}>
              <button
                className={
                  item?.sold == "0"
                    ? "success-button ml-3"
                    : "delete-button2 ml-3"
                }
                onClick={() => hendleToViewM(item)}
              >
                Sale
              </button>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
          </>
        );
      },
    },
  ];

  const [searchs, setsearch] = useState("");
  const handleChange = (e) => {
    setsearch(e);
    setPage(1);
    navigate("/product?page=" + 1 + "&search=" + e);
  };

  const [addPropertyModal, setAddPropertyModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [properties, setProperties] = useState([]);

  const hendlePahegi = (e) => {
    setPage(e);
    console.log(location);
    navigate("/product?page=" + e + "&&search=" + search);
  };
  const handleToAddProperty = async () => {
    const token = localStorage.getItem("admin_token");
    setloading(true);

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      if (!loading) {
        const response = await Api.post(
          `${URL.createPropertiesByExcel}`,
          { properties: properties },
          config
        );
        if (response.status === 200) {
          toast.success("Properties added successfully!!");
        }

        setAddPropertyModal(false);
        getPropertiesData();
        setloading(false);
        navigate(0);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Some error occured!!");
      setloading(false);
    }
  };
  const handleFileUpload = (event) => {
    const propertyExcel = event.target.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const binaryStr = new Uint8Array(e.target.result);
      const workbook = XLSX.read(binaryStr, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const propertyData = XLSX.utils.sheet_to_json(worksheet);
      setProperties(propertyData);
    };

    reader.readAsArrayBuffer(propertyExcel);
  };

  const downloadExampleExcel = () => {
    const link = document.createElement("a");
    link.href = "../media/property/example.xlsx";
    link.download = "example.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadSchemes = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const response = await Api.get(`${URL.getcateAllList}`, config);
    const data = response.data?.data;

    if (data.length === 0) {
      toast.error("No Schemes found");
    } else {
      let schemes = data.map((item) => {
        return {
          scheme_name: item?.name,
          id: item?._id,
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "SVK_Schemes.xlsx");
    }
  };
  return (
    <div>
      <Modal
        title="delete User"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure delete</p>
      </Modal>

      <Modal
        title="Sale"
        centered
        open={statusDataBox}
        onOk={() => hendleToSubmetUpdate(false)}
        onCancel={() => setstatusDataBox(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>User</Col>
            <Col span={24}>
              {/* <Input
                name="amount"
                placeholder="enter amount"
                value={statusData?.amount}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              /> */}

              <AsyncPaginate
                value={userselete}
                loadOptions={loadOptionsPalyer}
                onChange={setuserselete}
                additional={{
                  page: 1,
                }}
              />
            </Col>
            <Col span={24}>Amount</Col>
            <Col span={24}>
              <Input
                name="amount"
                placeholder="enter amount"
                value={statusData?.amount}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              />
            </Col>
            <Col span={24}>Transation Id</Col>
            <Col span={24}>
              <Input
                name="transationId"
                placeholder="enter transation Id"
                value={statusData?.transationId}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              />
            </Col>
            <Col span={24}>Payment Mode</Col>
            <Col span={24}>
              {/* <Input
                name="paymentMode"
                placeholder="enter payment mode"
                value={statusData?.paymentMode}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              /> */}
              <select
                name="paymentMode"
                className="form-control mt-8"
                value={statusData?.paymentMode}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              >
                <option value={""}>Select payment Mode</option>
                <option value={"upi"}>Upi</option>
                <option value={"case"}>Case</option>
                <option value={"account"}>Account</option>
              </select>
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Add Property"
        centered
        open={addPropertyModal}
        onOk={handleToAddProperty}
        onCancel={() => setAddPropertyModal(false)}
        width={500}
        okText={loading ? "Loading..." : "Submit"}
      >
        <div>
          <Row>
            <Col span={24}>
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <div className="flex">
        <div>
          <HeadingBack
            title={"Plot"}
            subHeading={`Total ${get_product_list?.totalDocs || 0} Plot`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          />
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Download" placement="topRight">
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={downloadExampleExcel}
            >
              Example Excel
            </Button>
          </Tooltip>
          <Tooltip title="Download" placement="topLeft">
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={downloadSchemes}
            >
              Download Schemes
            </Button>
          </Tooltip>
          <Tooltip title="Add">
            <Button
              type="primary"
              className="jop_btn"
              onClick={() => setAddPropertyModal(true)}
            >
              Add Property
            </Button>
          </Tooltip>
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => navigate("/add-product")}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          className={"table antd_table"}
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: get_product_list?.totalDocs
              ? get_product_list?.totalDocs
              : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Product;
